module.exports = __webpack_public_path__ + "img/Slide1.a6881d86.png";